import React from 'react';
import { Card } from 'antd';

import PageTitle from '../../../components/PageTitle';
import ShippingAddress from '../../../components/ShippingAddress';

import './index.css';

function WarehouseAddress() {
  return (
    <div className="WarehouseAddress">
      <PageTitle>仓库地址</PageTitle>

      <Card bordered={false}>
        <p>电商网站下单或让家人邮寄包裹至我们仓库，地址格式如下(单击每行即可复制)：</p>

        <ShippingAddress />
      </Card>
    </div>
  );
}

export default WarehouseAddress;
